import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MerchantSearchMediatorService } from './shared/services/mediators/merchant-search-mediator.service';
import { AuthGuard } from './shared';

const routes: Routes = [
	{
		path: '',
		loadChildren: './layout/layout.module#LayoutModule',
		// './layout/sales-entity/sales-entity.module#SalesEntityModule',
		canActivate: [AuthGuard],
		canLoad: [AuthGuard]
	},
	{
		path: 'logout/:redirect',
		loadChildren: './logout/logout.module#LogoutModule'
	},
	{
		path: 'not-found',
		loadChildren: './not-found/not-found.module#NotFoundModule'
	},
	{
		path: 'error',
		loadChildren: './no-permission/error.module#ErrorModule'
	},
	{ path: '**', redirectTo: 'not-found' }
];

@NgModule({
	imports: [
		// RouterModule.forRoot(routes, { useHash: true, enableTracing: true }), // FIXME: Remove "enableTracing: true" from prod!
		RouterModule.forRoot(routes, { useHash: true })
	],
	exports: [RouterModule],
	providers: [MerchantSearchMediatorService]
})
export class AppRoutingModule {}
